// extracted by mini-css-extract-plugin
export default {"tag":"status_tag__+AoPf","dot":"status_dot__T1fpt","green":"status_green__h35Rm","blue":"status_blue__pVSh3","gray":"status_gray__WkZTq","purple":"status_purple__bgnqE"};